import { useRef } from "react";
import type { LockLight } from "../../../../http/lock_calculator/types";
import { useLocks } from "../../../../http/lock_calculator/useLocks";

/**
 * Catalog entry of a lock (family, code), read from the lock select.
 * The saved calculation is not a reliable source for the family: some responses return it empty.
 * null = no id or not in the catalog; undefined = the catalog has not loaded yet.
 */
export const useLockCatalogEntry = (
  lockItemId: string | null | undefined,
  isAdmin: boolean,
): LockLight | null | undefined => {
  const aborter = useRef(new AbortController());
  const { data } = useLocks({ limit: 200, page: 1, q: "" }, aborter.current.signal, isAdmin);
  if (!lockItemId) return null;
  if (!data) return undefined;
  return data.items.find((lock) => lock.id === lockItemId) ?? null;
};

/** Family ("MIDI" | "MINI") of the chosen first connector lock — see useLockCatalogEntry. */
export const useFirstLockFamily = (
  firstLockItemId: string | null | undefined,
  isAdmin: boolean,
): string | null | undefined => {
  const entry = useLockCatalogEntry(firstLockItemId, isAdmin);
  return entry === undefined ? undefined : (entry?.family ?? null);
};
